module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-two"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("atasha sat in the little chair in the corner, still clutching her knapsack, her chin resting on the top of it, her brown hair hiding her face.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" At least she wasn’t crying anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey sat down beside her, perched awkwardly on a chair made for six-year-old bottoms. She folded her hands on her lap, saying nothing, simply being there for the little girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As if finally sensing her presence, Natasha looked up. Her red-rimmed eyes and tear-stained cheeks plucked at Hailey’s heartstrings.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha dragged her coat sleeve across her face, drying her eyes. “Is my daddy come yet?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “He’s talking to Miss Tolsma for a few minutes. As soon as they’re done he’ll come to get you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I want to be with my daddy. I don’t want to be in this school.” Natasha looked down at her knapsack, fiddling with a tiny stuffed rabbit hanging from the zipper pull.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m sure your daddy wants to be with you too.” Hailey laid her hand on Natasha’s tiny shoulder.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha shook her head. Hailey heard her draw in a trembling breath and her shoulders shook with silent sorrow, as if she had no hope her cries would be acknowledged.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey’s heart broke for the little girl adrift without her mother and living in an unfamiliar place.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You know your daddy loves you very much,” Hailey said, giving the little girl’s hand a squeeze. “He wants to take very good care of you and he wants you to learn. That’s why he put you in school.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha’s silent cries only increased. Hailey couldn’t stand watching her. She pulled the little girl onto her lap. Natasha made a token protest, then wilted against Hailey, her arms twined around her neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey wrapped her arms around the tiny, slender body, rocking slowly back and forth and making shushing noises. Natasha burrowed her head in Hailey’s neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I don’t want to be sad,” she murmured, sniffing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I know you miss your mom and this place is different. It’s okay to be sad about that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha drew in a shuddering breath. “Daddy said I shouldn’t talk about my mommy,” she said. “Because it makes me cry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey felt torn. She didn’t want to go against Dan’s parenting, but she also wanted to look out for Natasha.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You can talk about your mommy to me, if you want,” Hailey said. “You can tell me anything you want about her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha considered this, then lay against Hailey again. “I really like you,” she whispered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I like you too,” Hailey replied, stroking Natasha’s damp hair away from her face. She clung to the little girl. Dan’s little girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" What if Austin’s accident hadn’t happened? What if Dan had stayed in Hartley Creek? Would the little girl in her arms be her and Dan’s?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The light touch of a hand on her shoulder made her jump. Hailey yanked herself back from her meandering thoughts, then just about fell off the chair when she turned and saw Dan pull his hand back from her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A frown pulled his eyebrows together as he looked down at her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She was so upset…she was crying… I didn’t know what to do.” Hailey stumbled through her excuses, wondering why she felt she had to explain her behavior.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But Dan’s direct gaze made her feel as if she had stepped over some invisible boundary.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He bent over and lifted Natasha away from Hailey and the little girl tucked herself into his arms. He stroked her hair just as Hailey had, tucking Natasha’s head under his chin as he held her close.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Just as Hailey had.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s okay, honey,” he murmured to his daughter. “We’re making this better for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey glanced over to Megan standing by the front doorway to the class, one arm crossed over her chest, her other hand tucked under her chin while she watched Dan and his little girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey beat a retreat to her friend’s side.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Did you figure something out?” Hailey asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Megan ran her forefinger across her chin, as if drawing out her thoughts. Then she turned to Hailey. “We’ve decided that Natasha would do better with a tutor who could work with her in her home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey looked back to Dan, now perched on the edge of the small table, still holding his daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Good idea, but where will you find a tutor in Hartley Creek?” she asked, watching as Dan rocked slowly back and forth, comforting his daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As a father has compassion on his children…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The Bible verse that had comforted her so often in the dark days following Austin’s accident slipped into her mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan was a good father, so unlike her own.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Megan turned away from Dan to Hailey, lowering her voice. “I’m thinking this might be a good job for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey’s attention jerked away from Dan to her friend. “What, what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Shush. Use your church voice,” Megan whispered, holding her finger to her lips. “You and I both know that this little girl needs more help than any of the children in the classroom. When I saw you holding her on your lap, I knew you were exactly the right person for this job.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I don’t think so.” She couldn’t see Dan on a regular basis. That would put too heavy a strain on her emotions.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “But think of Natasha,” Megan urged. “That little girl is overwrought. She recently lost her mother. She needs some kind of direction and she has obviously formed an attachment to you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey pressed her lips together as her sympathy for Natasha swayed her reasoning.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Megan sensed her wavering and put her hand on Hailey’s shoulder. “I think you’re exactly the right person for the job,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey shrugged, her reluctance battling with her sympathy for Natasha. “You can think all you want, but I’m sure Dan won’t go for your plan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We’ll see,” was all Megan would say.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" They walked over to where Dan sat, still holding Natasha. The little girl lay quietly in his arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan looked up when they came close, a raw hope in his eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I have a temporary solution to your problem.” Megan gave Dan a bright smile. “I’ve talked to Hailey about your situation and she is willing to tutor your daughter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan’s gaze flicked over Hailey and then returned to Megan. “I don’t think that’s an option,” was his blunt response.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I feel it’s a reasonable solution,” Megan replied, brushing aside his objections. “Hailey and Natasha obviously have some kind of bond.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan’s only reply was to lift Natasha, stand up and settle her on his hip. Then he glanced over at Hailey. For a moment, as their eyes met, she caught a flicker of older emotions, a hearkening back to another time. Her heart faltered in response.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “This won’t work,” he said, then turned and walked away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey watched him leave, the definite tone in his voice cutting her to the core. Though Hailey had known Dan wouldn’t agree, she didn’t think he would be so adamant about it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She wondered why she cared. Her response to him showed her she wasn’t over Dan Morrow at all. And if she wasn’t over Dan, she certainly shouldn’t be teaching his daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('br'), _c('br'), _vm._v(" “Natasha, don’t play with that, honey.” Dan took the cardboard-and-cellophane box holding the baby doll away from his daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It was Saturday afternoon and he and his mother had spent most of the day doing damage control, keeping his daughter from running up and down the aisles, fingering the china displays and playing with the toys in the store. Patricia, the store’s only employee, manned the register.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “But it’s pretty and I don’t have a doll like that.” Natasha stuck out her lip in a classic pout as she dropped onto the wooden floor, her green fairy dress puddling around her in a mass of glittery chiffon and satin.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan carefully closed the box and put it back up on the shelf with the rest of the toys. “Come with me to the front,” he said, taking his daughter’s hand. “Patricia said she has a game for you to play.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She jerked her hand away just as his cell phone rang out. Without bothering to check the caller, he pulled it from his pocket and answered it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We’ve been trying to call you for the past two days,” a voice accused him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" At the sound of the woman’s voice Dan’s heart sank. Lydia’s mother. Carla Anderson.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I want the doll,” Natasha called out, pulling away from Dan as he tried to control her and use his phone. Thankfully the store had hit a lull and Dan didn’t have to deal with any customers right now.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Is that Natasha?” Carla asked, her voice raising an octave. “What is wrong with her?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She’s fine.” The only thing wrong with her was she wasn’t getting what she wanted. “And what can I do for you, Carla?” he asked, forcing himself to smile. He’d read somewhere that if you smile even if you don’t feel like it, your voice sounds more pleasant. And he needed that pleasant tone right now. Every conversation with his mother-in-law since Lydia’s death had been a battle over who would take care of Natasha. He had custody, but Lydia’s parents brought it up at every turn.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" In the weeks after Lydia’s death Dan deliberately kept everyone out of his daughter’s life just so he could cement his relationship with Natasha. He wanted to give her stability, create a connection. He’d had such little time with his daughter when Lydia was alive. However, in Dan’s opinion that had meant keeping everyone, even his own parents, at arm’s length for those first critical weeks after Lydia’s death.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Now he lived in Hartley Creek and Carla and Alfred were still in Vancouver, and they’d been pushing harder and harder with each phone call.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I want to talk to Natasha,” Carla was saying. “I haven’t talked to her for a couple of days.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan looked down at his sniffling daughter, then at the checkout counter. His mother was bagging some items for Miranda Klauer. The store was quiet, so he had time to supervise the phone call.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Okay. I’ll put her on,” Dan said, as he took Natasha’s hand and walked toward the door leading to his and Natasha’s apartment above the store. They stepped into the stairwell and closed the door, leaving it open a crack so he could give them some privacy and yet keep an eye on what was going on outside.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s your gramma,” he said to his daughter, lowering the phone and covering the mouthpiece. “She wants to talk to you. Do you want to talk to her?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha gave a halfhearted nod and Dan gave her the phone.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She lifted it, frowning just a bit, as if unsure what she would hear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hi, Grandmother…I’m fine… Yes, I love my daddy. And he loves me.” Natasha sat down on the first stair, fidgeting with a piece of her skirt as she listened to her grandmother. “My Gramma and Grandpa Deacon are really nice too.... It’s cold here but I don’t have to go to school.” Natasha looked over at Dan, puzzlement crossing her features. “Because my daddy said so… My daddy can homeschool me, like my mommy did.” Her frown deepened with each pause in the conversation as she listened to what her grandmother was saying. “But I like being with my daddy and I don’t want to live with you—”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Fury rose up in Dan and he had to stop himself from snatching the phone away from Natasha. “I need to talk to Grandmother Anderson,” he said, keeping his voice calm as he held out his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Thankfully, Natasha willingly gave the phone up.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan took in a deep breath, then another, then raised the phone to his ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We have all kinds of fun toys and I can take you to the park all the time because it’s not cold here,” Carla Anderson was saying.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “This is Dan.” His words came out clipped and he didn’t bother smiling this time. “What are you doing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A pause greeted his angry question, then Carla cleared her throat. “I was merely pointing out to Natasha the advantages of residing with us. And I think they are numerous.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan massaged the bridge of his nose, praying for patience, praying he didn’t lose it in front of Natasha, who was watching him from her perch on the stair.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We are not having this discussion now.” He pitched his voice low, hoping he sounded nonthreatening. Hoping the fear twisting his gut didn’t come out in his voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He’d spent almost six years of Natasha’s short life battling with his ex-wife to get her to respect Dan’s court-ordered weekend visits with his daughter. He had struggled not to run to court every time Lydia had decided this weekend she might take Natasha out of town, or Natasha was too sick to come, or any other lame excuse. He didn’t want Natasha to become a pawn in their battle. But it had been difficult not to succumb when a month could go by with no visit.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Sad as Lydia’s death had been, in one way, for Dan, it had been a relief from the constant tension of battling over visits with his daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Then, shortly after the funeral, he’d received a phone call from Lydia’s brother, a lawyer, warning Dan that his parents wanted to sue for custody of Natasha. Since then the battle lines had been drawn and Mr. and Mrs. Anderson had slowly advanced, revealing their strategy one methodical step at a time.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The past few days their tactic had been to convince Natasha she wanted to live with them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We’re not giving up on Natasha.” Carla warned. “We have much to give her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan bit back an angry reply. Mr. and Mrs. Anderson owned a condo in Hawaii, a twenty-six-foot yacht anchored in the Victoria Harbor, a small private plane and a home just outside of Vancouver with more square footage than both his parents’ hardware store and the grocery store beside it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She’s my daughter,” he said, “and I will take care of her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “That may be, but she said she’s not going to school. How is that taking care of her?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan should have known Carla wouldn’t have missed one beat in Natasha’s conversation. “She’s having a hard time adjusting.” No sooner had the words left his lips than he felt like banging his head on the wall behind him. Why give them any kind of ammunition? What kind of idiot was he?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You do realize your daughter needs to attend school. That is still required,” Carla replied, a note of triumph in her voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The all-too-familiar panic rose up in him as he felt himself backed into a corner. He glanced over at Natasha. She was smiling at him, rocking back and forth on the stair. He wasn’t letting her go. Never.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Mrs. Anderson was still talking. “If you aren’t responsible enough to take care of her schooling, perhaps we will have to—”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m getting a tutor,” he snapped, cutting her off mid-threat. He leaned back against the wall behind him, the old cliché of being stuck between a rock and a hard place suddenly becoming very real. Could he hire Hailey? See her every day?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Maybe there was another way. Someone else to tutor Natasha.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I see.” Mrs. Anderson’s clipped tone showed him that he had, for now, caused her to retreat. “Then I guess we’ll have to see how things pan out for her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes, we will.” Dan experienced a momentary reprieve and, to his disappointment, one of his knees began to bounce, an involuntary reaction to stress. He pushed it down and forced a smile that came more naturally this time. “And now I’m saying goodbye.” He ended the call before Mrs. Anderson could ask to speak to Natasha again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He laid his head back against the wall, closing his eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Are you tired, Daddy?” Natasha asked him, tugging on his hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He looked down at her, feeling the weight of his responsibilities. He was tired. Tired of trying to balance all the emotions his homecoming had created. Tired of trying to do it all himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" In spite of what he had told Natasha’s grandmother, however, he wasn’t sure he was ready to have Hailey tutor his daughter every day. Surely he could find someone else to do the job.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, honey. I’m fine.” He dropped his phone in his pocket and took her hand. “Now, let’s go see if Gramma needs any help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('br'), _c('br'), _vm._v(" Hailey smoothed her hair, pressed her lips together and then caught herself mid-preen as she walked out of the cloakroom. It’s church, silly. And like last week, Dan won’t be here anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" In spite of her self-chiding, she still tugged on the wide leather belt cinching her knit dress, pressed her lips together to even out her lipstick, then threaded her way through the people gathered in the foyer, toward the doors leading to the sanctuary.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She paused in the doorway, glancing around the church, looking for a place to sit. Shannon was working at the hospital this morning and her Nana wanted to sleep in, so neither of them would be here this morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She caught sight of her cousin Carter’s dark head bent over his fiancée, Emma, her son, Adam, sitting on his lap. People sat on either side of them, so it didn’t look like there was room for her there.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Miss Deacon. Miss Deacon,” Natasha’s voice called out over the buzz of conversation from the lobby. Hailey’s heart skipped its next beat.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She turned to see Dan’s tall figure moving through the people gathered in the foyer. His dark blond hair still glistened with moisture, as if he had stepped right out of the shower, gotten dressed and come here. As Natasha pulled him closer she also saw a line of blood trickling from a cut on his cheek. Probably shaved as quickly as he had dressed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Miss Deacon, you come to church too?” Natasha asked, beaming with pleasure.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes. I do.” Hailey returned her smile, yet couldn’t stop her eyes from drifting toward Dan.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He wore a blue blazer over a light blue shirt. No tie, and jeans with cowboy boots. Just as he always did. And just as before, one point of his collar was tucked under the lapel of his blazer and the other lay overtop.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey had to stop herself from reaching out to straighten it. As she always did.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hello, Hailey,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey hoped her smile looked as polite and emotionless as his. Then she noticed the trickle of blood heading dangerously close to his collar.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You’re bleeding,” Hailey said, pointing to his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan grimaced and lifted his hand to the wrong cheek. Without thinking Hailey pulled a tissue out of her purse and pressed it to his face. She felt the warmth of his cheek through the tissue.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan, however, pulled back, smearing the blood.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Sorry. So sorry,” she said, angry at how breathless she sounded. “It’s just the blood was going to stain the collar of your shirt. I thought I should stop it. I didn’t mean—”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Stop now, she chastised herself as she handed him the tissue again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He took it from her and slowly wiped his cheek. “I should go to the washroom and clean this up,” he said. “Would you mind watching Natasha for me?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey gave a tight shake of her head, pulling her gaze away from him. She drew in a long, careful breath. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Please Lord, help me through this, ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("she prayed. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I’ll be seeing him from time to time. Just let me get my silly emotions settled down.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As Dan left, Natasha caught Hailey’s hand in hers, clinging to it. “I wanted to wear my fairy wings to church so I could look like an angel, but my Daddy said I couldn’t.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey dragged her attention from Dan’s retreating back to the little girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha swung Hailey’s hand as if they had known each other for years instead of only a few days.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I think you look like an angel now,” Hailey returned.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I don’t like this dress, but my daddy said I had to wear it.” Natasha pulled at the dress, her blue cotton tied at the waist. White tights and black patent leather shoes finished the look.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You look really nice,” Hailey said, but from the look of Natasha’s sloppy ponytail she suspected Dan hadn’t had much luck with her hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “My daddy said we had to hurry to get to church so we could sit with Gramma and Grandpa, but I want to sit with you,” Natasha said, looking up at Hailey.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You better wait to see what your daddy says,” Hailey returned. Knowing the tension surrounding them each time they got together, she doubted Dan would give in to that request.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" People moved past, smiling at her and Natasha. A few stopped to chat, but most walked directly into the sanctuary. Finally Dan appeared again. The cut on his cheek was only a tiny red line and seemed to have stopped bleeding.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Without looking at her, Dan reached for Natasha’s hand. “We should go, sweetie,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But Natasha wouldn’t let go of Hailey. “I want to sit with Miss Deacon.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m sure Miss Deacon has her own place to sit,” he said, motioning her forward.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But Natasha wouldn’t move.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey saw Dan press his lips together and tried to release Natasha’s death grip on her own fingers. “You should go with your daddy,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha’s lips thinned and she gave a quick shake of her head as she gave Hailey a determined look. “I want to sit with you.” Her voice rose on that last word and people already seated in the sanctuary were looking back at them. Some looked concerned, some grinned, and Hailey sensed Dan’s growing frustration.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan tried one more time to take Natasha away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I want to be with Miss Deacon,” she called out as Dan took her hand firmly in his.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A few more heads turned and a few titters flew around the sanctuary. And in case neither Dan nor Hailey understood Natasha’s determination, she emphasized her little pique with a stamp of her foot.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey looked over Natasha’s head at Dan. “I don’t mind if you and her sit with me,” she said, giving him a gracious way to give in to Natasha.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan drummed his fingers on his thigh, then gave a reluctant nod of his head. “Okay. I guess we can.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" In spite of the tension of the moment Hailey couldn’t stop a tiny frisson of pleasure at the thought of sitting with him. She dragged her attention back to Natasha. “I guess we’ll need to find an empty spot,” she said to the little girl. Then without another glance at Dan, she turned and walked down the aisle, searching for a place near the back where they wouldn’t be too obvious.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As they passed Carter and Emma, she caught Carter looking at her and Natasha. Hailey averted her glance, but not soon enough to miss the smirk on her cousin’s face. A flush heated her cheeks, but she kept her head up and finally found a spot at the end of a pew. Hailey slipped into the empty space, Natasha right behind her. And Dan right behind Natasha.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey settled into the pew and, as Natasha slipped her arm into hers, tried not to look over at Dan. Thankfully the service started and the first song was announced. Hailey reached for the songbook at the same time as Dan. As their fingers brushed, she pulled her own hand back, curling her fingers against her palm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan simply opened the book to the correct page and held it out for her to follow along.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Please help me get through this service, ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("she prayed as she folded her hands together and sang along. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Please help me to stay focused on You, Lord, and not be distracted by Dan.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" When the song was over Hailey sat down and kept her gaze forward, concentrating on the worship team. The pastor. Anything but the man sitting a couple of feet away.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Natasha leaned contentedly against Hailey, swinging her feet back and forth, her arm tucked in Hailey’s. By the time the pastor started preaching, however, Hailey felt Natasha’s body grow heavier and heard her breathing slow.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" She shot a quick glance down at the girl, surprised to see her eyes closed. Dan seemed to have noticed too. He reached over to take her from Hailey, but even in her sleep, Natasha clung to Hailey, shifted, then laid her head on Hailey’s lap.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hailey looked down at the little girl’s face, so relaxed and innocent in sleep. Her heart faltered and she couldn’t stop her hand from lightly brushing the child’s hair back from her face, then letting her hand rest on Natasha’s shoulder. She looked over at Dan at the same time he looked at her, and in his eyes she caught a fleeting glimpse of sadness. It’s not my fault, she wanted to say, as she did not understand the strange attachment the young girl seemed to have to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dan held her gaze a moment, then looked down at Natasha. He reached over and put his hand on her arm, as if laying his own claim to the little girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The service flowed on and still Natasha slept, her warmth and vulnerability creating a surprising feeling of protectiveness in Hailey.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But, to her shame, in spite of focusing her attention on the pastor, she was far too aware of Dan’s hand resting only inches from hers.")])])])]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623409d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 81
// module chunks = 0